import { graphql } from '~/gql'

export default graphql(`
  query Product($productId: ID!) {
    Product(id: $productId) {
      ...ProductFragment
    }
  }
`)
